import React, { Component } from "react";
import equal from "deep-equal";
import find from "lodash/find";
import { cyan500 } from "material-ui/styles/colors";
import { Flex, Box } from "rebass";
import DropDownMenu from "material-ui/DropDownMenu";
import MenuItem from "material-ui/MenuItem";
import { Card } from "material-ui/Card";
import { ViewTitle } from "admin-on-rest/lib/mui";
import IconTitle from "../components/icon_title";
import { CubeGrid } from "../components/spinkit";
import { RestApiTicket } from "../restClient";
import TicketInputForm from "./TicketInputForm";

class TicketScan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      dataProduct: {},
      itemSelectvariants: "",
      selectVariant: {},
      variants: [],
      isShowContent: false,
      selectSKU: ""
    };
  }

  componentDidMount() {
    const { id } = this.props.match.params;
    this.loadProducts(id);
  }
  loadProducts = params => {
    RestApiTicket(params)
      .then(response => {
        if (response.status >= 400) {
          this.setState({
            isLoading: false
          });
          throw new Error("Bad response from server");
        }
        return response.json();
      })
      .then(data => {
        if (
          data.hasOwnProperty("variant") &&
          data.variant.hasOwnProperty("variants") &&
          data.variant.variants.length > 0
        ) {
          const datasummary = data.variant.variants[0];
          const item = find(data.summaries, o => equal(o.sku, datasummary.sku));
          const dataVariantActive = data.variant.variants.filter(
            item => item.active
          );
          //console.log(item);
          this.setState({
            dataProduct: data,
            isLoading: false,
            itemSelectvariants: datasummary.name,
            selectVariant: datasummary.variant,
            variants: dataVariantActive,
            selectSKU: item.sku
          });
        } else {
          this.setState({
            isLoading: false
          });
        }
      })
      .catch(e => {
        this.setState({
          isLoading: false
        });
        //console.error(e);
      });
  };
  handleChange = (event, index, value, summaries) => {
    const data = this.state.variants[index];
    // const dataVariant = find(summaries, o => equal(o.sku, data.sku));
    //console.log(dataVariant);
    this.setState({
      itemSelectvariants: value,
      selectVariant: data.variant,
      isShowContent: true,
      selectSKU: data.sku
    });
  };
  renderInfo() {
    if (this.state.isLoading) {
      return (
        <div>
          <CubeGrid size={80} color={cyan500} />
        </div>
      );
    }
    const { summaries } = this.state.dataProduct;
    if (summaries && summaries !== null && summaries.length > 0) {
      //console.log(this.state.selectVariant);
      return (
        <Flex wrap direction="column">
          <Box pb={[2]}>
            <DropDownMenu
              value={this.state.itemSelectvariants}
              onChange={(event, index, value) =>
                this.handleChange(event, index, value, summaries)
              }
            >
              {this.state.variants.map((item, index) => (
                <MenuItem
                  value={item.name}
                  primaryText={item.name}
                  key={index}
                />
              ))}
            </DropDownMenu>
          </Box>
          {this.state.isShowContent && (
            <TicketInputForm
              detailProduct={this.state.dataProduct}
              selectVariant={this.state.selectVariant}
              selectSKU={this.state.selectSKU}
            />
          )}
        </Flex>
      );
    }
    return (
      <Flex align="center" justify="center">
        <Box p={[2]}>data not Found or product type not "Ticket"</Box>
      </Flex>
    );
  }

  render() {
    const { dataProduct } = this.state;
    const name = dataProduct.name ? dataProduct.name : "";
    return (
      <Card containerStyle={{ minHeight: 300, paddingBottom: 0 }}>
        <ViewTitle
          title={<IconTitle icon="calendar" title={name} isTranlate={false} />}
        />
        <Box px={[2]}>{this.renderInfo()}</Box>
      </Card>
    );
  }
}

export default TicketScan;



// WEBPACK FOOTER //
// ./src/tickets/TicketScan.js